import { render } from "./BaseFile.vue?vue&type=template&id=0630c5ec&scoped=true&ts=true"
import script from "./BaseFile.vue?vue&type=script&lang=ts"
export * from "./BaseFile.vue?vue&type=script&lang=ts"

import "./BaseFile.vue?vue&type=style&index=0&id=0630c5ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0630c5ec"]])

export default __exports__